import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import ReputationData from 'lib/components/reputation-data'

const Reputation = ({ reputation, showAddVerificationLink }) => {
  return (
    <div className='widget nospace clearfix'>
      <h3 className='boxtitle line'>{I18n.t('profiles.show_right.online_reputation')}</h3>
      <div style={{ margin: '15px 20px 15px 20px' }}>
        <ReputationData data={reputation} showChecks />
        {showAddVerificationLink ? (
          <div style={{ marginTop: 10 }}>
            <a href='/profile/verifications'>{I18n.t('profiles.profile_layout.add_verification')}</a>
          </div>
        ) : null}
      </div>
    </div>
  )
}

Reputation.propTypes = {
  reputation: PropTypes.object,
  showAddVerificationLink: PropTypes.bool
}

export default Reputation
